/* istanbul ignore file */

import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-20px);
  }
`;

export const AnimatedFiltersWrapper = styled.div<{ isVisible: boolean }>`
    animation: ${({ isVisible }) =>
        isVisible
            ? css`
                  ${fadeIn} 0.3s ease-in-out forwards
              `
            : css`
                  ${fadeOut} 0.3s ease-in-out forwards
              `};
    visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
    height: ${({ isVisible }) => (isVisible ? 'auto' : 0)};
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    animation-fill-mode: forwards;
    transition: visibility 0.3s ease-in-out;

    max-width: 264px;
    min-width: 264px;
    overflow: hidden;
`;

export const FilterOptionsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.tokens.BaseSpace15};
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace15};
`;

export const FiltersSidePanelTitle = styled.h3`
    margin: 0;
    font-size: ${({ theme }) => theme.tokens.BaseTypeSizeXl};
`;

export const FiltersSidePanelHeader = styled.div`
    margin-bottom: ${({ theme }) => theme.tokens.BaseSpace40};
    display: flex;
    align-items: center;
    min-height: 32px;
    justify-content: space-between;
`;
